import { Image } from "antd";
import { moneyFormat } from "../../plugins/numberFormat";
import gold from "./icon/gold.png";
import styles from "./style.module.scss";
const CustomGiftPoint = ({ number = 0, label = "" }) => {
  return (
    <div className={styles.goldContainer}>
      <Image src={gold} alt="gold" preview={false} />
      <div className={styles.goldText}>{moneyFormat(number)}</div>
    </div>
  );
};

export default CustomGiftPoint;
